import { Check } from "lucide-react";
import { SmartTip } from "@/components/SmartTip";

export const Field = ({ f, value, setValue }) => {
  const base =
    "w-full bg-white border border-[#E5E7EB] focus:border-[#041C3E] outline-none px-4 py-3 text-sm transition-colors";
  const label = (
    <label className="flex items-center text-sm font-semibold text-[#041C3E] mb-2">
      {f.label} {f.required && <span className="text-[#D94833] ml-1">*</span>}
      <SmartTip text={f.tip} name={f.name} />
    </label>
  );
  if (f.type === "textarea") {
    return (
      <div data-testid={`field-${f.name}`}>
        {label}
        <textarea rows={3} value={value || ""} onChange={(e) => setValue(f.name, e.target.value)} className={base} />
      </div>
    );
  }
  if (f.type === "select") {
    return (
      <div data-testid={`field-${f.name}`}>
        {label}
        <select value={value || ""} onChange={(e) => setValue(f.name, e.target.value)} className={base}>
          <option value="">Select</option>
          {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
    );
  }
  if (f.type === "checks") {
    const arr = Array.isArray(value) ? value : [];
    const toggle = (o) => setValue(f.name, arr.includes(o) ? arr.filter((x) => x !== o) : [...arr, o]);
    return (
      <div data-testid={`field-${f.name}`}>
        {label}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {f.options.map((o) => {
            const on = arr.includes(o);
            return (
              <button type="button" key={o} data-testid={`check-${f.name}-${o}`} onClick={() => toggle(o)}
                className={`flex items-center gap-2 text-left px-3 py-2.5 text-sm border transition-colors ${
                  on ? "border-[#041C3E] bg-[#041C3E] text-white" : "border-[#E5E7EB] bg-white hover:border-[#041C3E]"
                }`}>
                <span className={`w-4 h-4 border flex items-center justify-center shrink-0 ${on ? "border-white" : "border-[#9CA3AF]"}`}>
                  {on && <Check size={12} />}
                </span>
                {o}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
  if (f.type === "scale10") {
    return (
      <div data-testid={`field-${f.name}`}>
        {label}
        <div className="flex flex-wrap gap-1.5">
          {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
            <button type="button" key={n} data-testid={`scale-${f.name}-${n}`} onClick={() => setValue(f.name, n)}
              className={`w-9 h-9 text-sm font-semibold border transition-colors ${
                value === n ? "border-[#D94833] bg-[#D94833] text-white" : "border-[#E5E7EB] bg-white hover:border-[#041C3E]"
              }`}>
              {n}
            </button>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div data-testid={`field-${f.name}`}>
      {label}
      <input type={f.type === "tel" ? "tel" : f.type === "date" ? "date" : f.type === "email" ? "email" : f.type === "url" ? "url" : "text"}
        value={value || ""} onChange={(e) => setValue(f.name, e.target.value)} className={base} />
    </div>
  );
};

export const Likert = ({ statements, values, onChange, testPrefix }) => (
  <div className="space-y-3">
    {statements.map((s, i) => (
      <div key={i} data-testid={`${testPrefix}-row-${i}`}
        className="flex flex-col sm:flex-row sm:items-center gap-3 border-b border-[#F3F4F6] pb-3">
        <p className="flex-1 text-sm text-[#162030]"><span className="text-[#9CA3AF] mr-2">{i + 1}.</span>{s}</p>
        <div className="flex gap-1.5 shrink-0">
          {[1, 2, 3, 4, 5].map((n) => (
            <button type="button" key={n} data-testid={`${testPrefix}-${i}-${n}`} onClick={() => onChange(i, n)}
              className={`w-9 h-9 text-sm font-semibold border transition-colors ${
                values[i] === n ? "border-[#041C3E] bg-[#041C3E] text-white" : "border-[#E5E7EB] bg-white hover:border-[#041C3E]"
              }`}>
              {n}
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);
